module.exports = __webpack_public_path__ + "img/对勾.639a2133.svg";